import { render, staticRenderFns } from "./OrdersMainPage.vue?vue&type=template&id=65b9d27c&scoped=true"
import script from "./OrdersMainPage.vue?vue&type=script&lang=js"
export * from "./OrdersMainPage.vue?vue&type=script&lang=js"
import style0 from "./OrdersMainPage.vue?vue&type=style&index=0&id=65b9d27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b9d27c",
  null
  
)

export default component.exports